















































import { SimilarityFaultCaseType } from '@/interfaces/types/AnalysisResult';
import { downloadLocalData } from '@/utils/axiosAgentInstance';
import Vue, { PropType } from 'vue';
export default Vue.extend({
  props: {
    data: {
      type: Object as PropType<SimilarityFaultCaseType>,
    },
    rootPath: {
      type: String,
    },
    type: {
      type: String,
      default: 'error',
    },
  },
  data(): {
    isExpanded: boolean;
    imageFullPath: string[];
    imageSourceURL: (string | null)[];
  } {
    return {
      isExpanded: false,
      imageFullPath: [
        this.rootPath + '/' + this.data.image1,
        this.rootPath + '/' + this.data.image2,
      ],
      imageSourceURL: [null, null],
    };
  },
  mounted() {
    this.isExpanded = false;
  },
  watch: {
    async isExpanded(value) {
      // TBD : Loading & 404 Icon
      if (value && (!this.imageSourceURL[0] || !this.imageSourceURL[1])) {
        this.imageSourceURL[0] = await downloadLocalData(
          this.imageFullPath[0],
          'image',
        );

        this.imageSourceURL[1] = await downloadLocalData(
          this.imageFullPath[1],
          'image',
        );

        // Quick Update by injecting sourceURL,
        // w/o this, the images not showing on initial expanding.
        if (this.imageSourceURL[0]) {
          (this.$refs.image1 as HTMLImageElement).src = this.imageSourceURL[0];
          (this.$refs.imageRef1 as HTMLAnchorElement).href =
            this.imageSourceURL[0];
        }
        if (this.imageSourceURL[1]) {
          (this.$refs.image2 as HTMLImageElement).src = this.imageSourceURL[1];
          (this.$refs.imageRef2 as HTMLAnchorElement).href =
            this.imageSourceURL[1];
        }
      }
    },
  },
  methods: {
    async toggleExpand(e: Event) {
      const senderName = (e.target as HTMLElement).tagName;

      if (senderName !== 'IMG') this.isExpanded = !this.isExpanded;
    },
    copyFullPath(index: number) {
      window.navigator.clipboard.writeText(this.imageFullPath[index]);
    },
  },
});
